<template>
  <v-tooltip :value="tooltip" top :open-on-hover="false" :open-on-focus="false">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        small
        :color="color"
        @click="click"
      >
        {{ custom_icon }}
      </v-icon>
    </template>
    <span>{{ tooltip_text }}</span>
  </v-tooltip>
</template>

<style lang="scss">

</style>

<script>
  export default {
    name: 'TooltipButton',

    props: {
      custom_icon: {},
      color: {},
      tooltip_text: {},
    },
    data() {
      return {
        tooltip: false,
      }
    },

    computed: {
    },

    methods: {
      update_tooltip(tooltip) {
        this.tooltip = tooltip;
      },

      click(something) {
        this.tooltip= true;
        setTimeout(() => {this.tooltip= false;},1000);
        this.$emit('click',something);
      },
    },
  }
</script>